<div class="login-root">
  <div class="login-columns">
    <div class="login-image-col" aria-hidden="true">
      <app-auth-hero-panel [hero]="hero()" />
    </div>
    <div class="login-form-col">
      <div class="login-form-wrapper">
        <div class="logo-container">
        <img src="assets/icons/aio-logo-black.svg" alt="Logo" class="login-logo" />
        </div>

        <!-- Success Message -->
        @if (successMessage()) {
          <div class="success-message" role="alert" style="color: #4CAF50; text-align: center; margin-bottom: 1rem; padding: 0.75rem; background-color: #E8F5E8; border-radius: 4px;">
            {{ successMessage() }}
          </div>
        }

        <!-- Error Message -->
        @if (errorMessage()) {
          <div class="error-message" role="alert">
            <img src="assets/icons/warning.svg" alt="Warning" class="error-icon" />
            {{ errorMessage() }}
          </div>
        }

        <!-- Show dashboard link if already authenticated -->
        @if (authService.isAuthenticated()) {
          <div class="already-logged-in">
          <p>You are already logged in.</p>
          <a (click)="goToDashboard()" class="dashboard-link" style="cursor: pointer;" [title]="'Navigate to ' + getDashboardUrl()">Go to Dashboard</a>
          <button type="button" class="logout-link" (click)="logout()">Logout</button>
        </div>
        }

        <!-- Show login form if not authenticated -->
        @if (!authService.isAuthenticated()) {
          <form [formGroup]="loginForm" class="login-form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email" class="form-label">Email Address</label>
            <div class="input-icon-group">
              <input
                id="email"
                type="email"
                class="form-input"
                  [class.input-error]="showFieldErrors() && loginForm.get('email')?.invalid"
                  [class.input-locked]="loginLocked()"
                placeholder="name@example.com"
                  formControlName="email"
                (input)="clearError()"
                required
              />
              <img src="assets/icons/account_circle.svg" alt="Account" class="input-icon" aria-hidden="true" />
            </div>
              @if (showFieldErrors() && loginForm.get('email')?.invalid) {
                <div class="field-error">
                  @if (loginForm.get('email')?.errors?.['required']) {
                    Email address is required
                  } @else if (loginForm.get('email')?.errors?.['email']) {
                    Please enter a valid email address
                  }
                </div>
              }
          </div>
          <div class="form-group">
            <label for="password" class="form-label">Password</label>
            <div class="input-icon-group">
              <input
                id="password"
                  [type]="passwordVisible() ? 'text' : 'password'"
                class="form-input"
                  [class.input-error]="showFieldErrors() && loginForm.get('password')?.invalid"
                  [class.input-locked]="loginLocked()"
                  placeholder="••••••••"
                  formControlName="password"
                (input)="clearError()"
                required
              />
                <span class="input-icon eye-icon" [class.eye-open]="passwordVisible()" (click)="passwordVisible.set(!passwordVisible())" tabindex="0" role="button" aria-label="Show/Hide password"></span>
              </div>
              @if (showFieldErrors() && loginForm.get('password')?.invalid) {
                <div class="field-error">
                  @if (loginForm.get('password')?.errors?.['required']) {
                    Password is required
                  }
            </div>
              }
            <div class="forgot-row">
              <a routerLink="/forgot-password" class="forgot-link">Forgot password?</a>
            </div>
          </div>

            <aio-button
              appearance="brand"
              size="lg"
              type="submit"
              [block]="true"
              [disabled]="!canSubmit()"
              [loading]="loading()"
              class="login-button">
              {{ loading() ? 'Logging in...' : 'Log In' }}
            </aio-button>

          <div class="login-links">
            <span class="new-to">New to AIO?</span>
            <a href="https://www.aio.build/" class="signup-link" target="_blank" rel="noopener noreferrer">Get started here</a>
          </div>
        </form>
        }
        <app-auth-footer></app-auth-footer>
      </div>
    </div>
  </div>
</div>
